import request from '@/utils/request'

// 获取订单详情
export function getList(params) {
  return request({
    url:'/Crm.Orders/orders_view',
    method:'get',
    params:params
  })
}

// 新建订单
export function ordersAdd(data) {
  return request({
    url:'/Crm.Orders/orders_add',
    method:'post',
    data:data
  })
}

// 订单修改
export function ordersUpdate(data) {
  return request({
    url:'/Crm.Orders/orders_update',
    method:'post',
    data:data
  })
}
// 修改订单行项目
export function ordersItemsUpdate(data) {
  return request({
    url:'/Crm.Orders/ordersItemsUpdate',
    method:'post',
    data:data
  })
}

// 订单删除
export function ordersDelete(data) {
  return request({
    url:'/Crm.Orders/orders_delete',
    method:'post',
    data:data
  })
}

// 订单列表
export function ordersList(params) {
  return request({
    url:'/Crm.Orders/orders_list',
    method:'get',
    params:params
  })
}

// 删除订单行项目
export function ordersLineDelete(data) {
  return request({
    url:'/Crm.Orders/order_line_delete',
    method:'post',
    data:data
  })
}
// CRM订单行项目添加
export function ordersLineAdd(data) {
  return request({
    url:'/Crm.Orders/order_line_add',
    method:'post',
    data:data
  })
}
// CRM订单审核
export function orderVerify(data) {
  return request({
    url:'/Crm.Orders/orderVerify',
    method:'post',
    data:data
  })
}
// CRM订单返审核
export function orderDeaudit(data) {
  return request({
    url:'/Crm.Orders/orderDeaudit',
    method:'post',
    data:data
  })
}
// CRM返审采购确认
export function orderPurchaseRetrials(data) {
  return request({
    url:'/Crm.Orders/orderPurchaseRetrials',
    method:'post',
    data:data
  })
}
// CRM关闭订单
export function closeOrder(data) {
  return request({
    url:'/Crm.Orders/closeOrder',
    method:'post',
    data:data
  })
}
// CRM再次购买
export function buyAgain(data) {
  return request({
    url:'/Crm.Orders/buyAgain',
    method:'post',
    data:data
  })
}
// CRM导入EXCEL到订单
export function ImportExcelToOrder(data) {
  return request({
    url:'/Crm.Orders/ImportExcelToOrder',
    method:'post',
    data:data
  })
}
// 导出订单到EXCEL
export function exportOrderToExcel(params) {
  return request({
    url:'/Crm.Orders/exportOrderToExcel',
    method:'get',
    params:params,
    responseType: "blob"
  });
}
// 导出订单未发数到EXCEL
export function exportOrderUnsettledNumberToExcel(params) {
  return request({
    url:'/Crm.Orders/exportOrderUnsettledNumberToExcel',
    method:'get',
    params:params,
    responseType: "blob"
  });
}

// 订单销售历史
export function salesOrderHistory(params) {
  return request({
    url:'/Crm.Orders/salesOrderHistory',
    method:'get',
    params:params
  })
}
// 订单销售历史
export function SalesHistorySummary(params) {
  return request({
    url:'Crm.Orders/SalesHistorySummary',
    method:'get',
    params:params
  })
}
// 销售历史导出EXCEL
export function exportSalesHistoryToExcel(params) {
  return request({
    url:'/Crm.Orders/exportSalesHistoryToExcel',
    method:'get',
    params:params,
    responseType: "blob"
  });
}
// 获取订单信息
export function orderReminder(params) {
  return request({
    url:'/Crm.Orders/orderReminder',
    method:'get',
    params:params
  })
}

// 计划跟踪
export function OrderLineList(params) {
  return request({
    url:'/CRM.PlanTracking/OrderLineList',
    method:'get',
    params:params
  })
}
// 计划跟踪导出EXCEL
export function ExportOrderLinesToExcel(params) {
  return request({
    url:'/CRM.PlanTracking/ExportOrderLinesToExcel',
    method:'get',
    params:params,
    responseType: "blob"
  });
}
// 计划跟踪导入EXCEL
export function importData(data) {
  return request({
    url:'/Crm.PlanTracking/Import_data',
    method:'post',
    data:data
  })
}

// 同步金蝶采购申请单
export function syncRequisition(data) {
  return request({
    url:'/Crm.Orders/syncRequisition',
    method:'post',
    data:data
  })
}

//同步采购申请单
export function NewsyncRequisition(data) {
  return request({
    url:'/Crm.Orders/new_syncRequisition',
    method:'post',
    data:data
  })
}

// 一键业务确认
export function confirm(data) {
  return request({
    url:'/Crm.Orders/confirm',
    method:'post',
    data:data
  })
}

// 订单详情表头
export function HeaderCustomization(data) {
  return request({
    url:'/Crm.Orders/HeaderCustomization',
    method:'post',
    data:data
  })
}

//批量释放
export function TransitAllocationAll(data) {
  return request({
    url:'/Crm.PlanTracking/CancelInTransitAllocationAll',
    method:'post',
    data:data
  })
}

//导出
export function OrdersExport(params) {
  return request({
    url:'/Crm.Orders/orders_export',
    method:'get',
    params:params,
    responseType: "blob"
  });
}


// WEBPACK FOOTER //
// ./src/api/order.js